import type { CalculationEndpointType, Terms } from '@makemydeal/dr-platform-types';
export const CALC_ENDPOINTS: {
    programQuotes: CalculationEndpointType;
    userProgramQuotes: CalculationEndpointType;
} = {
    programQuotes: '/program-quotes',
    userProgramQuotes: '/user-program-quotes'
};

export const OFFER_TERMS: Terms = {
    byId: {},
    allIds: [],
    mappings: {},
    leaseTerms: [],
    financeTerms: [],
    balloonTerms: []
};
